import React from 'react';
import { bool, shape, string } from 'prop-types';

const SoilWorks = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M22.2707 6.40625L20.1496 8.52832C19.2261 9.45181 17.8516 9.64379 16.7365 9.11133L11.6633 14.1846L14.4924 17.0127L12.2512 19.2539C9.69333 21.8116 5.98112 22.84 2.47187 21.9629C1.59452 18.4535 2.62206 14.7406 5.17987 12.1826L7.42108 9.94238L10.2492 12.7705L15.3225 7.69727C14.7907 6.58244 14.9833 5.20836 15.9064 4.28516L18.0285 2.16406L22.2707 6.40625ZM6.59491 13.5967C4.83427 15.3573 3.97352 17.7969 4.20038 20.2334C6.63682 20.4603 9.07642 19.6004 10.8371 17.8398L11.6642 17.0127L10.2492 15.5986L8.83515 14.1846L7.42108 12.7705L6.59491 13.5967ZM17.3205 5.69922C16.93 6.08974 16.93 6.72375 17.3205 7.11426L17.3967 7.18262C17.7894 7.50301 18.3694 7.48035 18.7355 7.11426L19.4426 6.40625L18.0285 4.99219L17.3205 5.69922Z" fill="currentColor" />
  </svg>
);

SoilWorks.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default SoilWorks;
